import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { VehicleAction } from "stores/vehicles/VehicleAction";

const mapStateToProps = (state) => {
  return {
    vehicleDataList:state.vehicleData.vehicleDataList,
    getVehiclesTypedata:state.vehicleData.getVehiclesTypedata,
    postVehilceList:state.vehicleData.postVehilceList,
    VehicleDropdownDataList:state.vehicleData.VehicleDropdownDataList,
    postVehilceBulkList:state.vehicleData.postVehilceBulkList,
    getModeldropdowndata:state.vehicleData.getModeldropdowndata,
    getVariantdropdowndata:state.vehicleData.getVariantdropdowndata,
    isLoading:state.vehicleData.vehicledataloading.isLoading,
    getMenufacturerdropdowndata:state.vehicleData.getMenufacturerdropdowndata,
    getVehiclesSubTypedata:state.vehicleData.getVehiclesSubTypedata
};
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { getVehicleSubTypeData:VehicleAction.getVehicleSubTypeData,
      getVehicleMenufaturerData:VehicleAction.getVehicleMenufaturerData,
      getVehicleTypeDataAction:VehicleAction.getVehicleTypeData,
      getVehicleData: VehicleAction.getVehicleData,
      postVehicleData: VehicleAction.postVehicleData,
      getVehicleDropdownDataAction: VehicleAction.getVehicleDropdownData,
      postVehicleBulkData: VehicleAction.postVehicleBulkData,
      getVehicleModelData:VehicleAction.getVehicleModelData,
      getVehicleVariantData:VehicleAction.getVehicleVariantData
    },
    dispatch
  );

const VehiclesStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default VehiclesStore;
